import { styles } from './template.scss';
import { InputWidthValues } from '../../../../../ui/gzInput';
import { FontSizes } from '../../../../../types/common/types';

export const templateGzCredentialsManagerGrid = document.createElement('template');

templateGzCredentialsManagerGrid.innerHTML = `
  <style>${styles}</style>
  <div class='wrapper'>
    <gz-grid-view id='credentials-manager-grid' showGlobalActions>
      <div slot='grid-header-actions-slot' class='credentials-patch'>
        <div id='credentials-boxes'>
          <gz-form-field id='user-field' class='' label=''>
            <gz-input id='user-input' gz-form-input placeholder='' inputWidth='${InputWidthValues.MEDIUM}'></gz-input>
            <gz-input-error inputWidth='${InputWidthValues.MEDIUM}'></gz-input-error>
          </gz-form-field>
          <gz-form-field id='authentication-type-field' class='hidden'>
            <gz-dropdown gz-form-input type='dropdown' labelWidth='${InputWidthValues.MEDIUM}'></gz-dropdown>
            <div id='size-helper-wrapper' class='hidden'>
              <p id='size-helper-text'></p>
            </div>
            <gz-input-error inputWidth='${InputWidthValues.MEDIUM}'></gz-input-error>
          </gz-form-field>
          <gz-form-field class='pt-3' label='' id='pem-files-field' class='hidden'>
            <gz-file-input gz-form-input accept='.pem' type='quiet' color='secondary' id='pem-files-input'>
                <gz-button
                  id='browse-pem-files-button'
                  browse-button
                  type='outline'
                  color= 'primary'
                  buttonHeight='medium'
                  buttonFontSize='medium'
                >
                </gz-button>
            </gz-file-input>
            <gz-input-error></gz-input-error>
          </gz-form-field>
          <gz-input id='pem-file-path-field' placeholder='' inputWidth='${InputWidthValues.MEDIUM}' disabled class='hidden'></gz-input>
          <gz-form-field id='password-field' class='hidden' label=''>
            <gz-input id='password-input' gz-form-input type='password' placeholder='' inputWidth='${InputWidthValues.MEDIUM}'></gz-input>
            <gz-input-error inputWidth='${InputWidthValues.MEDIUM}'></gz-input-error>
          </gz-form-field>
          <gz-form-field id='description-field' class='' label=''>
            <gz-input id='description-input' gz-form-input placeholder='' inputWidth='${InputWidthValues.MEDIUM}'></gz-input>
            <gz-input-error inputWidth='${InputWidthValues.MEDIUM}'></gz-input-error>
          </gz-form-field>
          <gz-icon-button id='add-credentials-button' size='${FontSizes.HEADING_2}' fontSize='${FontSizes.BODY}' buttonType='square' icon='ds-icon-add' buttonFill='primary'></gz-icon-button>
          <gz-form-field id='credentials-manager-form-field-validation' class='hidden'>
            <gz-dropdown gz-form-input localFiltering type='dropdown'></gz-dropdown>
          </gz-form-field>
        </div>
      </div>
      <div slot='no-results--additional-data' id='no-results-subtitle'></div>
    </gz-grid-view>
    <gz-text id='credentials-manager-info-note' fontSize='${FontSizes.PARAGRAPH_13}'></gz-text>
    <gz-info-box id='credentials-manager-grid-box-info' class='hidden info-box-style' severity='warning'></gz-info-box>
  </div>
`;
